// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchWithinStyles } from "@awc/Overrides/Widgets/ProductList/ProductListSearchWithin";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { css } from "styled-components";

searchWithinStyles.titleText = {
    forwardAs: "p",
    size: fontConfig.fontSize.small,
    weight: fontConfig.weight.medium,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    css: css`
        margin-bottom: 4px;
    `,
};

searchWithinStyles.searchFieldWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 12px;
    `,
};

searchWithinStyles.searchTextField = {};

searchWithinStyles.searchButton = {
    sizeVariant: "small",
    css: css`
        padding: 8px;
        border: 0;
    `,
};
